import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PrivacyPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Helmet>
        <title>Privacy Policy | EquipEASE Lease Co.</title>
        <meta name="description" content="EquipEASE Lease Co. privacy policy. Learn how we collect, use, and protect your personal information." />
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href="https://equipease.ca/privacy" />
      </Helmet>
      
      <Header />
      
      <section className="flex-1 py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto bg-white p-8 md:p-12 rounded-lg shadow-lg">
            <h1 className="text-4xl font-bold mb-8 text-[#333333]">Privacy Policy</h1>
            
            <div className="prose prose-lg max-w-none text-[#4A4A4A] space-y-6">
              <p>
                This privacy policy sets out how EquipmentEASE Lease Co. uses and protects any information that you give EquipEASE Lease Co. when you use this website.
              </p>

              <p>
                EquipmentEASE Lease Co. is committed to ensuring that your privacy is protected. Should we ask you to provide certain information by which you can be identified when using this website, then you can be assured that it will only be used in accordance with this privacy policy.
              </p>

              <p>
                EquipmentEASE Lease Co. may change this policy from time to time by updating this page. You should check this page from time to time to ensure that you are happy with any changes. This policy is effective from November 10, 2022.
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4 text-[#333333]">What we might collect</h2>
              <p>
                We might collect the following information in order to provide information or services to you when using our website information request forms, subscriptions to newsletters, or contacting our representatives and staff by phone. We only collect personally identifiable information that you submit voluntarily. You may withdraw your consent at any time. Some of the personally identifiable information we may gather from you on a volunteer basis is:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>name and job title</li>
                <li>contact information including email address and telephone</li>
                <li>demographic information such as postal code, mailing address, preferences and interests</li>
                <li>other information relevant to customer surveys and/or offers</li>
              </ul>

              <h2 className="text-2xl font-bold mt-8 mb-4 text-[#333333]">What we do with the information we gather</h2>
              <p>
                EquipEASE Lease Co. collects personal information only with the express consent of the individual when they request information from our company. This information is only used when communicating with individuals as per their indicated preferences and as needed for service-related communications. We may use the information you provide for:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Internal record keeping.</li>
                <li>to improve our products and services.</li>
                <li>to send promotional communication, special offers, or other information which we think you may find interesting using the email address which you have provided.</li>
                <li>From time to time, we may also use your information to contact you for market research purposes. We may contact you by email, phone, or mail.</li>
                <li>We may use the information to customize the website according to your interests.</li>
              </ul>

              <h2 className="text-2xl font-bold mt-8 mb-4 text-[#333333]">Opting Out</h2>
              <p>
                EquipEASE Lease Co. provides users with the ability to opt out (unsubscribe) from communications from any of our newsletters. An opt out option will either appear at the bottom of a newsletter received by email, or users can reply directly to the emailed newsletter and request removal from that correspondence. By opting out, you withdraw your consent to use your personal information as indicated above.
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4 text-[#333333]">What we will not do with your information</h2>
              <p>
                EquipEASE Lease Co. wishes to maintain positive customer relationships. As such, we will not use your information in the following ways:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Sell, rent, or share it with 3rd parties that have not already been authorized by you</li>
                <li>Tarnish reputations or use it for slanderous purposes</li>
                <li>To impersonate you in any way</li>
              </ul>

              <h2 className="text-2xl font-bold mt-8 mb-4 text-[#333333]">Lawful Requirements</h2>
              <p>
                We are required by law to provide your information to police, law enforcement, or other official judiciary officers when compelled to do so by the court (warrant) or the laws of Canada. Your privacy is then governed by the laws of Canada, or the country compelling us to provide your personal information.
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4 text-[#333333]">Security</h2>
              <p>
                We are committed to ensuring that your information is secure. In order to prevent unauthorized access or disclosure we have put in place suitable physical, electronic and managerial procedures to safeguard and secure the information we collect online.
              </p>

              <h2 className="text-2xl font-bold mt-8 mb-4 text-[#333333]">How we use cookies</h2>
              <p>
                A cookie is a small file which asks permission to be placed on your computer's hard drive. Once you agree, the file is added and the cookie helps analyze web traffic or lets you know when you visit a particular site. Cookies allow web applications to respond to you as an individual. The web application can tailor its operations to your needs, likes and dislikes by gathering and remembering information about your preferences.
              </p>

              <p>
                We use traffic log cookies to identify which pages are being used. This helps us analyze data about web page traffic and improve our website in order to tailor it to customer needs. We only use this information for statistical analysis purposes and much of it is anonymized.
              </p>

              <p>
                Overall, cookies help us provide you with a better website, by enabling us to monitor which pages you find useful and which you do not. A cookie in no way gives us access to your computer or any information about you, other than the data you choose to share with us.
              </p>

              <p>
                You can choose to accept or decline cookies. Most web browsers automatically accept cookies, but you can usually modify your browser setting to decline cookies if you prefer. This may prevent you from taking full advantage of the website.
              </p>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default PrivacyPage;
